/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoUpdateDonationPayment } from '../../models/dto-update-donation-payment';

export interface BookingControllerUpdateDonationPayment$Params {
  payment_identifier: string;
      body: DtoUpdateDonationPayment
}

export function bookingControllerUpdateDonationPayment(http: HttpClient, rootUrl: string, params: BookingControllerUpdateDonationPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerUpdateDonationPayment.PATH, 'patch');
  if (params) {
    rb.path('payment_identifier', params.payment_identifier, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

bookingControllerUpdateDonationPayment.PATH = '/booking/donation/{payment_identifier}';
